module.exports = __webpack_public_path__ + "img/discord.d8ffb9a8.svg";